/* eslint class-methods-use-this: 0 */
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { ColumnDefinition } from '@interfaces/central-monitoring';

enum ReviewLogColumns {
    CreatedDate = 'created_date',
    Id = 'id',
    ClosedDatePopulatedOn = 'closed_date_populated_on',
    RecordId = 'record_id',
    Comments = 'comments',
    Association = 'association',
    Panel = 'panel',
    Decision = 'decision',
    DataSet = 'dataset',
    UpdatedDate = 'updated_date',
    CreatedBy = 'created_by',
    DataListing = 'data_listing',
    ObsId = 'observation_record_id',
    ActionsCount = 'actions_count',
    UpdatedBy = 'updated_by',
}

export class SmReviewLogsGridHelper implements IGridHelper {
    _isChild: boolean;

    private _customCells: CustomCells;

    constructor(
        private isChild: boolean | null | undefined,
        private customCells: CustomCells,
    ) {
        this._isChild = !!isChild;
        this._customCells = customCells;
    }

    disableAdvancedFilter(): boolean {
        return false;
    }

    disableLock(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case ReviewLogColumns.DataSet:
            case ReviewLogColumns.ObsId:
            case ReviewLogColumns.Association:
            case ReviewLogColumns.Panel:
            case ReviewLogColumns.DataListing:
            case ReviewLogColumns.Decision:
                return this._isChild;
            default:
                return false;
        }
    }

    getActiveField(columnType: ColumnDefinition): string | undefined {
        switch (columnType.dataField) {
            case ReviewLogColumns.Association:
            case ReviewLogColumns.Panel:
            case ReviewLogColumns.DataListing:
            case ReviewLogColumns.Decision: {
                return `${columnType.dataField}_active`;
            }
            default:
                return undefined;
        }
    }

    reviewLogsColumnsWidth: Map<string | null | undefined, number> = new Map([
        [ReviewLogColumns.DataSet, 145],
        [ReviewLogColumns.ObsId, 100],
        [ReviewLogColumns.Association, 180],
        [ReviewLogColumns.Panel, 180],
        [ReviewLogColumns.DataListing, 180],
        [ReviewLogColumns.Decision, 190],
        [ReviewLogColumns.Comments, 200],
        [ReviewLogColumns.UpdatedDate, 145],
        [ReviewLogColumns.UpdatedBy, 145],
        [ReviewLogColumns.CreatedDate, 145],
        [ReviewLogColumns.CreatedBy, 145],
        [ReviewLogColumns.RecordId, 100],
    ]);

    getColumnWidth(columnType: ColumnDefinition): number | undefined {
        return this.reviewLogsColumnsWidth.get(
            this._isChild && columnType.dataField === ReviewLogColumns.Panel ? 'child_panel' : columnType.dataField,
        );
    }

    getCustomCell(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            default:
                return undefined;
        }
    }

    getDisplayFields(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case ReviewLogColumns.CreatedDate:
            case ReviewLogColumns.Id:
            case ReviewLogColumns.CreatedBy:
            case ReviewLogColumns.RecordId:
            case ReviewLogColumns.ActionsCount:
                return false;
            default:
                return true;
        }
    }

    getDisplayTooltipFields(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case ReviewLogColumns.Association:
            case ReviewLogColumns.Panel:
            case ReviewLogColumns.DataListing:
            case ReviewLogColumns.Decision:
            case ReviewLogColumns.Comments:
                return true;
            default:
                return false;
        }
    }

    isRagColumn(): boolean {
        return false;
    }

    multiValueFilter(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            default:
                return false;
        }
    }
}
